import React from 'react';
import styled, { keyframes } from 'styled-components';

export default function LoadingSpinner() {
    return (
        <SpinnerContainer>
            <Spinner />
            <LoadingText> Loading</LoadingText>
        </SpinnerContainer>
    );
}

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;    
`;

const Spinner = styled.div`
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: ${props => props.theme.application.scheme.primary};
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.span`
    margin-left:20px
`
